import { Form, Select } from "antd";
import styled from "styled-components";
import { MinusCircleOutlined } from "@ant-design/icons";
import { theme } from "../../../config";

export const ItemWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  justify-content: center;
`;

export const FormItem = styled(Form.Item)`
  margin-right: 16px;
  height: 55px;
  ${theme.formErrorMobileView}

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 48px;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: ${theme.colors.neutral.black2};
    border-radius: 4px;
    border: 1px solid ${theme.colors.borderColor};
    width: 185px;
    padding-top: 5px;
    ${theme.defaultInputStyle}
    @media ${theme.breakpoints.mobileAndTablet} {
      height: 30px;
      width: 100%;
      font-size: 12.6px;
      line-height: 16px;
      padding-top: 0;
    }
  }

  .ant-select-selector:disabled {
    color: ${theme.colors.neutral.black3};
  }

  .ant-select:not(.ant-select-customize-input)
    .ant-select-selector:hover:enabled {
    border: 1px solid ${theme.colors.secondary};
  }
`;

export const IconWrapper = styled.div`
  margin-bottom: 15px;
`;

export const MinusCircleIcon = styled(MinusCircleOutlined)`
  font-size: 20px;
  color: ${theme.colors.utilities.error};
`;

export const ButtonWrapper = styled.div`
  text-align: center;
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme.breakpoints.mobileAndTablet} {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
`;

export const InputTitle = styled.p`
  color: ${theme.colors.dark};
  text-align: start;
  width: 50%;
  padding-right: 19px;
  color: ${theme.colors.neutral.black1};
  font-size: 16px;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 13px;
  }
`;

export const Container = styled.div`
  padding-top: 13px;
`;

export const StyledSkillSelect = styled(Select)`
  .ant-select-selection-placeholder {
    font-size: 14px;
  }
  .ant-select-item-option-content {
    white-space: normal;
  }
`;
